$('#ola_orderLookUp_formWrapper h1#ola_formTitleText').empty().remove();
$('ul.menu li.navbar_ > a').attr('role','button');
$('ul.menu li.navbar_ > a').removeAttr('href');
$('ul.menu li.help-option > a').removeAttr('href');
$('ul.menu li.help-option > a').attr('role','button');
$('ul.menu li.flag-dropdown > a').removeAttr('href');
$('ul.menu li.flag-dropdown > a').attr('role','button');
$('section.product-tabs.tabs .product-description .description h5').attr('aria-level', '2');
$('#ola_lookupForm span#ola_orderEmailField label').attr('aria-hidden', 'true');
$('#ola_lookupForm span#ola_orderNumberField label').attr('aria-hidden', 'true');
$('#ola_lookupForm span#ola_orderEmailField input').attr('aria-label', 'Email Address');
$('#ola_lookupForm span#ola_orderNumberField input').attr('aria-label', 'Order Number');


$(document).ready(function () {
    setTimeout(function () {
$('.jdgm-random-link.jdgm-hidden').append('<span class="visually-hidden" aria-hidden="true">review link</span>');
$('.wufoo-form-container').attr('title','Team & Club, Corporate Partnership Registration');
$('body').prepend('<span id="subscribe_1" style="font-size:0; position: fixed; top:0;" aria-hidden="true">You will leaving statebicycle.com to a booking system on www.statebicycle.co.uk</span>');
$("a[href='http://www.statebicycle.co.uk']").attr('aria-describedby','subscribe_1');
$('body').prepend('<span id="subscribe_2" style="font-size:0; position: fixed; top:0;" aria-hidden="true">You will leaving statebicycle.com to a booking system on https://statebicycle.eu/</span>');
$("a[href='http://www.statebicycle.eu']").attr('aria-describedby','subscribe_2');
$('.grid-333.sec .list-of-links ul li:nth-child(13) a').attr('aria-label','affiliate, This link open in new tab, you will leaving statebicycle.com to www.avantlink.com');
$('.grid-333.sec .list-of-links ul li:nth-child(13) a').attr('target', 'blank');
$('.footer a[href="http://www.statebicycle.co.uk"]').attr('aria-describedby','bbl16');
$('body').prepend('<span id="bbl16" style="font-size:0; width: 0; height: 0px; line-height: 0px; display: flex; top:0;" aria-hidden="true">This link open in new tab, you will leaving statebicycle.com to www.statebicycle.co.uk</span>');
$('.footer a[href="http://www.statebicycle.eu"]').attr('aria-describedby','bbl17');
$('body').prepend('<span id="bbl17" style="font-size:0; width: 0; height: 0px; line-height: 0px; display: flex; top:0;" aria-hidden="true">This link open in new tab, you will leaving statebicycle.com to www.statebicycle.eu</span>');
$('.footer a[href="https://state-bicycle-co.wholesale.shopifyapps.com"]').attr('aria-describedby','bbl18');
$('body').prepend('<span id="bbl18" style="font-size:0; width: 0; height: 0px; line-height: 0px; display: flex; top:0;" aria-hidden="true">This link open in new tab, you will leaving statebicycle.com to state-bicycle-co.wholesale.shopifyapps.com</span>');
$('ol.flex-control-nav.flex-control-paging li:nth-child(1) a').attr('aria-label', 'for State Bicycle Co x The Beatles Collection - picture of bike and shop the collection, image ');
$('ol.flex-control-nav.flex-control-paging li:nth-child(2) a').attr('aria-label', 'for State Bicycle Co x The Beatles Collection - picture of bike and shop the collection text, image');
$('ol.flex-control-nav.flex-control-paging li:nth-child(1) a').attr('role', 'button');
$('ol.flex-control-nav.flex-control-paging li:nth-child(2) a').attr('role', 'button');
$("ul.flex-direction-nav li a.flex-prev").text('click to check pervious slide');
$("ul.flex-direction-nav li a.flex-next").text('click to check next slide');
$('.grid-333[href="https://state-bicycle-co.wholesale.shopifyapps.com/accounts/sign_up"]').attr('title');
var nestedSpan = $('#judgeme_product_reviews .jdgm-rev-widg__header h2');
nestedSpan.replaceWith(function() {
    return '<h1>'+$(this).html()+'</h1>';
});	

}, 3000);
}, 3000);


$(document).ready(function () {
    setTimeout(function () {
        $('#judgeme_product_reviews .jdgm-rev-widg__header h1').attr('class', 'h2');
        $("#judgeme_product_reviews .jdgm-rev-widg__header h1.h2").css({ 'margin-bottom' : '8px', });
        $('.jdgm-rev__header .jdgm-rev__author-wrapper .jdgm-rev__buyer-badge-wrapper .jdgm-rev__buyer-badge').addClass('without-after-element');
        $('.jdgm-rev__header .jdgm-rev__author-wrapper .jdgm-rev__buyer-badge-wrapper .jdgm-rev__buyer-badge').html('<span>Verified</span>');
        $('a.jdgm-random-link.jdgm-hidden').html('<span class="visually-hidden" aria-hidden="true">random link</span>');
    }, 5000);
}, 5000);


$('a[target="_blank"]').attr('aria-describedby','hmw');
$('body').prepend('<span id="hmw" style="font-size:0; position: fixed; top:0;" aria-hidden="true">This link open in new tab</span>');
$("ul.menu li.navbar_,.flag-dropdown,.help-option ").click(function(){
    $(this).toggleClass("oopen");
    $(this).siblings().removeClass("oopen");
});

$("ul.menu li.navbar_ a,.flag-dropdown a,.help-option a").click(function(){
    $(this).attr('aria-expanded', function (i, attr) {
        return attr == 'true' ? 'false' : 'true'
    });
    
});

$("ol.flex-control-nav.flex-control-paging li a").html('<span aria-hidden="true">slider buttons<span/>')
$('body').prepend('<span id="shop-logo" style="font-size:0; width: 0; height: 0px; line-height: 0px; display: flex; top:0;" aria-hidden="true">shop</span>'); 

$( document ).ready(function() {
    //wait until the last element (#checkout-step-shipping_method) being rendered
    var existCondition = setInterval(function() {
     if ($('.recommendation-modal__flag').length) { 
      clearInterval(existCondition);
      runMyFunction2();
     }
    }, 200);

    function runMyFunction2(){
     console.log("when pop-up comes on the screen");
     $('.recommendation-modal__container .recommendation-modal__content .recommendation-modal__flag img').attr('alt', 'pakistan flag');
    }
  }); 

  $( document ).ready(function() {
    //wait until the last element (#checkout-step-shipping_method) being rendered
    var existCondition = setInterval(function() {
     if ($('.bread-analytics-iframe').length) { 
      clearInterval(existCondition);
      runMyFunction2();
     }
    }, 200);

    function runMyFunction2(){
     $('.bread-analytics-iframe').attr('title', 'bread analytics');
    }
  }); 

  $( document ).ready(function() {
    //wait until the last element (#checkout-step-shipping_method) being rendered
    var existCondition = setInterval(function() {
     if ($('section.product-form').length) { 
      clearInterval(existCondition);
      runMyFunction2();
     }
    }, 200);

    function runMyFunction2(){
        console.log("ecomdev");
        $('.selector-wrapper select.single-option-selector').attr('aria-label','Variant Selected');
    }
  }); 

  $( document ).ready(function() {
    //wait until the last element (#checkout-step-shipping_method) being rendered
    var existCondition = setInterval(function() {
     if ($('h1#logo').length) { 
      clearInterval(existCondition);
      runMyFunction2();
     }
    }, 200);

    function runMyFunction2(){
        console.log("ecomdev022");
        $('iframe.wufoo-form-container').attr('title','Ready to get back on a bike, form');
    }
  }); 

  $( document ).ready(function() {
    //wait until the last element (#checkout-step-shipping_method) being rendered
    var existCondition = setInterval(function() {
     if ($('.jdgm-picture-fieldset__box-wrapper').length) { 
      clearInterval(existCondition);
      runMyFunction2();
     }
    }, 200);

    function runMyFunction2(){
        console.log("ecomdev-1");
        $('input.jdgm-picture-fieldset__input+div').addClass('choosereviewpicture');
        $(".choosereviewpicture").removeAttr('aria-label');
    }
  }); 
  $( document ).ready(function() {
    //wait until the last element (#checkout-step-shipping_method) being rendered
    var existCondition = setInterval(function() {
     if ($('.jdgm-rev-widg__header').length) { 
      clearInterval(existCondition);
      runMyFunction2();
     }
    }, 200);

    function runMyFunction2(){
        console.log("ecomdev-2222");
        $('.jdgm-form__rating-fieldset').attr('role','text');
    }
  }); 

  $( document ).ready(function() {
    //wait until the last element (#checkout-step-shipping_method) being rendered
    var existCondition = setInterval(function() {
     if ($('.mobile_reviews').length) { 
      clearInterval(existCondition);
      runMyFunction2();
     }
    }, 200);

    function runMyFunction2(){
        $('.mobile_reviews #judgeme_product_reviews').attr('id','mobrev');
    }
  }); 

jQuery("a[href='https://www.avantlink.com/programs/22249/']").attr("aria-label", "Affiliate, this link open in new tab, you will leaving statebicycle to avantlink.com");

jQuery("a[href='https://www.avantlink.com/programs/22249/']").attr("target", "_blank");

jQuery("a[href='http://www.statebicycle.eu']").attr("aria-label", "EU, this link open in new tab, you will leaving statebicycle to statebicycle.eu");
jQuery("a[href='http://www.statebicycle.eu']").attr("target", "_blank");

jQuery("a[href='https://state-bicycle-co.wholesale.shopifyapps.com']").attr("aria-label", "USA - Dealer Log In, this link open in new tab, you will leaving statebicycle to state-bicycle-co.wholesale");
jQuery("a[href='https://state-bicycle-co.wholesale.shopifyapps.com']").attr("target", "_blank");

$(".jdgm-prev-badge__stars").attr("role", "img");

  

  

  